<template>
  <div class="service-index">
    <div
      v-if="serviceContent"
      v-lazy-container="{ selector: 'img' }"
      class="content"
      v-html="serviceContent"
    />
    <div
      v-if="redirection"
      v-show="!isMobile"
      class="redirection">
      <v-btn
        class="btn"
        depressed
        color="primary"
        @click="clickRedirection"
      >
        點我預約
      </v-btn>
    </div>
    <p
      v-if="false"
      class="is-community"
    >
      此服務目前僅開放智生活社區用戶透過APP訂購
    </p>
  </div>
</template>

<script>
export default {
  props: {
    redirection: [Boolean, Object]
  },
  asyncData ({ params }) {
    return {
      serviceId: params.service,
      serviceName: params.serviceName,
      category: params.categoryId,
      categoryName: params.categoryName
    }
  },
  data () {
    return {
      isMobile: null,
      serviceContent: null
    }
  },
  computed: {
    service () {
      return this.$store.state.service.serviceData[parseInt(this.serviceId)]
    },
    isCommunity () { // 社區模式
      if (!this.$store.state.service.serviceData[parseInt(this.serviceId)]) return null
      if (!this.$store.state.service.serviceData[parseInt(this.serviceId)].serviceAddressMode) return null
      return this.$store.state.service.serviceData[parseInt(this.serviceId)].serviceAddressMode.id === 2
    }
  },
  mounted () {
    this.isMobile = screen.width <= 768
    this.replaceImageSrc()
  },
  methods: {
    clickRedirection () {
      if (!this.redirection) return
      this.$gaLogEvent('商品頁', `click_點我預約_導購_${this.serviceName}_${this.serviceId}`)
      let href = this.redirection.uri
      if (this.redirection.uri.includes('docs.google.com') &&
          this.redirection.uri.includes('entry.')) {
        // 導流制若為免費諮詢 uri 含 docs.google.com 及 entry.
        // 需把會員電話帶在uri後面
        href += this.$auth.user ? this.$auth.user.APhone : ''
      }
      window.open(href, '_blank')
    },
    replaceImageSrc () {
      this.serviceContent = this.service.content.replace(/<img([^>]*)src=["']([^"']*)["']([^>]*)>/gi, (match, p1, p2, p3) =>
        // 將 src 屬性替換為 data-src 屬性
        `<img${p1}data-src="${p2}"${p3}>`
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.redirection {
  text-align: center;
  padding-top: 30px;
  .btn {
    height: auto;
    width: 80%;
    padding: 16px;
    ::v-deep {
      span {
        font-size: pxTorem(24px);
        line-height: pxTorem(33px);
      }
    }
  }
}
.is-community {
  text-align: center;
  padding: 20px 0;
  color: $errorColor;
  font-weight: bold;
}
</style>
